import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-delete-cart-dialog',
  templateUrl: './delete-cart-dialog.html',
  styleUrls: ['./delete-cart-dialog.scss'],
})
export class DeleteCartDialogComponent implements OnInit {
  product: any

  cartId: any

  userType: any

  deleteAll = true

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.product = data.product
      this.cartId = data.cartId
      this.userType = data.userType
    })
    if (this.product) {
      this.deleteAll = false
    }
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.DELETE_QUOTE_CART,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
